import Raven from 'raven-js';
import { showLocalStorageFullToaster } from './../utils';
import { UIDEVENT } from './../constants';



const LOCALSTORAGE_KEY = `${UIDEVENT}-state`;
let isLocalStorageErrorVisible = false;

export const isQuotaExceeded = (e) => {
  let quotaExceeded = false;
  if (e) {
    if (e.code) {
      switch (e.code) {
        case 22:
          quotaExceeded = true;
          break;
        case 1014:
          // Firefox
          if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
            quotaExceeded = true;
          }
          break;
      }
    } else if (e.number === -2147024882) {
      // Internet Explorer 8
      quotaExceeded = true;
    }
  }
  return quotaExceeded;
};

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(LOCALSTORAGE_KEY);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    Raven.captureException(err);
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    try {
      localStorage.setItem(LOCALSTORAGE_KEY, serializedState);
    } catch(e) {
      if (isQuotaExceeded(e) && !isLocalStorageErrorVisible) {
        isLocalStorageErrorVisible = true;
        showLocalStorageFullToaster();
        Raven.captureMessage('Not enough storage is available to complete this operation.');
      }
    }
  } catch (err) {
    Raven.captureException(err);
  }
};



// WEBPACK FOOTER //
// ./src/store/localStorage.js